import styled from 'styled-components';
import { Button } from './button';

// Migration blocker: @rocketlane/ui Button has no compact link API that
// provides intrinsic height, inherited font size, and zero horizontal padding.
export const LinkButton = styled(Button).attrs({
  size: 'small',
  type: 'link',
})`
  font-size: inherit;
  height: auto;
  padding: 0;
`;
